import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import utility from "@/utility";

import Login from "@/views/Login";
import Logout from "@/views/Logout";
import Main from "@/views/main";
import NotFound from "@/views/error/not-found";

// Containers
const TheContainer = () => import('../components/app/TheContainer');

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: TheContainer,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () =>
          import(/* webpackChunkName: "users-index" */ "@/views/dashboard/index"),
        meta: {
          title: "ダッシュボード",
          parent: true
        }
      },
      {
        path: "recipes",
        name: "recipes",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/recipes/recipes-index"
            ),
        meta: {
          title: "レシピ一覧",
          parent: true
        }
      },
      {
        path: "recipes/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/recipes/recipes-create"
            ),
        meta: {
          title: "レシピ登録"
        }
      },
      {
        path: "recipes/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/recipes/recipes-show"
            ),
        meta: {
          title: "レシピ詳細"
        }
      },
      {
        path: "recipes/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/recipes/recipes-edit"
            ),
        meta: {
          title: "レシピ編集"
        }
      },
      {
        path: "download_recipes/:makerId?",
        name: "download_recipes",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/download/download-recipes-index"
            ),
        meta: {
          title: "レシピ一括ダウンロード",
          parent: true
        }
      },
      {
        path: "download_products/:makerId?",
        name: "download_products",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/download/download-products-index"
            ),
        meta: {
          title: "商品一括ダウンロード",
          parent: true
        }
      },
      {
        path: "import_recipes",
        name: "import_recipes",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/import/import-recipes-index"
            ),
        meta: {
          title: "一括登録レシピ確認",
          parent: true
        }
      },
      {
        path: "import_products",
        name: "import_products",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/import/import-products-index"
            ),
        meta: {
          title: "一括登録商品確認",
          parent: true
        }
      },
      {
        path: "message",
        name: "message",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/message/message-index"
            ),
        meta: {
          title: "メッセージ一覧",
          parent: true,
          isMaker: true
        }
      },
      {
        path: "message/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/message/message-show"
            ),
        meta: {
          title: "メッセージ詳細",
          isMaker: true
        }
      },
      {
        path: "administrators",
        name: "administrators",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/administrators/administrators-index"
            ),
        meta: {
          title: "運営管理者一覧",
          parent: true
        }
      },
      {
        path: "administrators/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/administrators/administrators-create"
            ),
        meta: {
          title: "運営管理者登録"
        }
      },
      {
        path: "administrators/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/administrators/administrators-show"
            ),
        meta: {
          title: "運営管理者詳細"
        }
      },
      {
        path: "administrators/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/administrators/administrators-edit"
            ),
        meta: {
          title: "運営管理者編集"
        }
      },
      {
        path: "questionnaires",
        name: "questionnaires",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/questionnaires/questionnaires-index"
            ),
        meta: {
          title: "アンケート一覧",
          parent: true
        }
      },
      {
        path: "questionnaires/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/questionnaires/questionnaires-create"
            ),
        meta: {
          title: "アンケート登録"
        }
      },
      {
        path: "questionnaires/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/questionnaires/questionnaires-show"
            ),
        meta: {
          title: "アンケート詳細"
        }
      },
      {
        path: "questionnaires/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/questionnaires/questionnaires-edit"
            ),
        meta: {
          title: "アンケート編集"
        }
      },
      {
        path: "products",
        name: "products",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/products/products-index"
            ),
        meta: {
          title: "商品一覧",
          parent: true
        }
      },
      {
        path: "products/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/products/products-create"
            ),
        meta: {
          title: "商品登録"
        }
      },
      {
        path: "products/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/products/products-show"
            ),
        meta: {
          title: "商品詳細"
        }
      },
      {
        path: "products/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/products/products-edit"
            ),
        meta: {
          title: "商品編集"
        }
      },
      {
        path: "maintenance",
        name: "maintenance",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/maintenance/maintenance-index"
            ),
        meta: {
          title: "メンテナンス設定",
          isProvider: true
        }
      },
      {
        path: "makers",
        name: "makers",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/makers/makers-index"
            ),
        meta: {
          title: "メーカー一覧",
          parent: true,
          isProvider: true,
          isPermitMakerView: true
        }
      },
      {
        path: "requests",
        name: "requests",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/requests/requests-index"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "商品サンプル依頼一覧" : "依頼一覧",
          parent: true,
          isMaker: true
        }
      },
      {
        path: "requests/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/requests/requests-show"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "商品サンプル依頼詳細" : "依頼詳細",
          isMaker: true
        }
      },
      {
        path: "makers/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/makers/makers-create"
            ),
        meta: {
          title: "メーカー登録",
          isProvider: true,
          isPermitMakerEdit: true
        }
      },
      {
        path: "makers/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/makers/makers-show"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "メーカー詳細" : "企業情報",
          isPermitMakerView: true
        }
      },
      {
        path: "makers/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/makers/makers-edit"
            ),
        meta: {
          title: "メーカー編集",
          isPermitMakerEdit: true
        }
      },
      {
        path: "maker_administrators",
        name: "maker_administrators",
        component: () =>
          import(
            /* webpackChunkName: "administrators-index" */ "@/views/maker-administrators/maker-administrators-index"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "メーカー管理者一覧" : "担当者一覧",
          parent: true
        }
      },
      {
        path: "maker_administrators/create",
        component: () =>
          import(
            /* webpackChunkName: "administrators-create" */ "@/views/maker-administrators/maker-administrators-create"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "メーカー管理者登録" : "担当者登録"
        }
      },
      {
        path: "maker_administrators/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-show" */ "@/views/maker-administrators/maker-administrators-show"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "メーカー管理者詳細" : "担当者詳細"
        }
      },
      {
        path: "maker_administrators/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "administrators-edit" */ "@/views/maker-administrators/maker-administrators-edit"
            ),
        meta: {
          title: store.getters["auth/isProvider"] ? "メーカー管理者編集" : "担当者編集"
        }
      },
      {
        path: "templates",
        name: "templates",
        component: () =>
          import(
            /* webpackChunkName: "templates-index" */ "@/views/templates/templates-index"
            ),
        meta: {
          title: "レビューテンプレート一覧",
          parent: true
        }
      },
      {
        path: "templates/create",
        component: () =>
          import(
            /* webpackChunkName: "templates-create" */ "@/views/templates/templates-create"
            ),
        meta: {
          title: "レビューテンプレート登録"
        }
      },
      {
        path: "templates/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "templates-show" */ "@/views/templates/templates-show"
            ),
        meta: {
          title: "レビューテンプレート詳細"
        }
      },
      {
        path: "templates/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "templates-edit" */ "@/views/templates/templates-edit"
            ),
        meta: {
          title: "レビューテンプレート編集"
        }
      },
      {
        path: "news",
        name: "news",
        component: () =>
          import(
            /* webpackChunkName: "news-index" */ "@/views/news/news-index"
            ),
        meta: {
          title: "お知らせ一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "news/create",
        component: () =>
          import(
            /* webpackChunkName: "news-create" */ "@/views/news/news-create"
            ),
        meta: {
          title: "お知らせ登録",
          isProvider: true
        }
      },
      {
        path: "news/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "news-show" */ "@/views/news/news-show"
            ),
        meta: {
          title: "お知らせ詳細",
          isProvider: true
        }
      },
      {
        path: "news/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "news-edit" */ "@/views/news/news-edit"
            ),
        meta: {
          title: "お知らせ編集",
          isProvider: true
        }
      },
      {
        path: "reminders",
        name: "reminders",
        component: () =>
          import(
            /* webpackChunkName: "reminders-index" */ "@/views/reminders/reminders-index"
            ),
        meta: {
          title: "アンケートと商品レビュー催促一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "reminder_histories/:id",
        name: "reminder_histories",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "reminder-histories-index" */ "@/views/reminder-histories/reminder-histories-index"
            ),
        meta: {
          title: "アンケート催促履歴一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "reminders/create",
        component: () =>
          import(
            /* webpackChunkName: "reminders-create" */ "@/views/reminders/reminders-create"
            ),
        meta: {
          title: "アンケートと商品レビュー催促登録",
          isProvider: true
        }
      },
      {
        path: "reminders/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "reminders-show" */ "@/views/reminders/reminders-show"
            ),
        meta: {
          title: "アンケートと商品レビュー催促詳細",
          isProvider: true
        }
      },
      {
        path: "inquiries",
        name: "inquiries",
        component: () =>
          import(
            /* webpackChunkName: "inquiries-index" */ "@/views/inquiries/inquiries-index"
            ),
        meta: {
          title: "お問い合わせ一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "masters",
        name: "masters",
        component: () =>
          import(
            /* webpackChunkName: "masters-index" */ "@/views/masters/masters-index"
            ),
        meta: {
          title: "マスタ一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "answers",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "answers-select" */ "@/views/answers/answers-select"
            ),
        meta: {
          title: "レビュー結果選択"
        }
      },
      {
        path: "answers/:productId/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "answers-index" */ "@/views/answers/answers-index"
            ),
        meta: {
          title: "レビュー質問一覧"
        }
      },
      {
        path: "answers/:productId/:questionId/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "answers-show" */ "@/views/answers/answers-show"
            ),
        meta: {
          title: "レビュー回答確認"
        }
      },
      {
        path: "users",
        name: "users",
        component: () =>
          import(
            /* webpackChunkName: "users-index" */ "@/views/users/users-index"
            ),
        meta: {
          title: "ユーザ一覧",
          isProvider: true,
          isPermitUserView: true,
          parent: true
        }
      },
      {
        path: "users/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "users-show" */ "@/views/users/users-show"
            ),
        meta: {
          title: "ユーザ詳細",
          isPermitUserView: true,
          isProvider: true
        }
      },
      {
        path: "topics",
        name: "topics",
        component: () =>
          import(
            /* webpackChunkName: "topics-index" */ "@/views/topics/topics-index"
            ),
        meta: {
          title: "特集ページ一覧",
          parent: true,
          isPermitArticleView: true
        }
      },
      {
        path: "topics/create",
        component: () =>
          import(
            /* webpackChunkName: "topics-create" */ "@/views/topics/topics-create"
            ),
        meta: {
          title: "特集ページ登録",
          isPermitArticleEdit: true
        }
      },
      {
        path: "topics/:pk",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "topics-show" */ "@/views/topics/topics-show"
            ),
        meta: {
          title: "特集ページ詳細",
          isPermitArticleView: true
        }
      },
      {
        path: "topics/:pk/edit",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "topics-edit" */ "@/views/topics/topics-edit"
            ),
        meta: {
          title: "特集ページ編集",
          isPermitArticleEdit: true
        }
      },
      {
        path: "push_advertisments",
        name: "push_advertisments",
        component: () =>
          import(
            /* webpackChunkName: "push-advertisments-index" */ "@/views/push-advertisments/push-advertisments-index"
            ),
        meta: {
          title: "Push通知一覧",
          parent: true,
          isProvider: true
        }
      },
      {
        path: "/logout",
        name: "logout",
        component: Logout,
        meta: { isPublic: true }
      },
      {
        path: "*",
        name: "dashboard",
        component: () =>
          import(/* webpackChunkName: "users-index" */ "@/views/dashboard/index"),
        meta: {
          title: "ダッシュボード",
          parent: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      redirect: { name: "login" }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { isPublic: true, title: '管理画面' }
    },
    {
      path: "/manual",
      name: "manual",
      component: () =>
        import(/* webpackChunkName: "users-index" */ "@/views/manual/manual-index"),
      meta: {
        title: "マニュアル",
        parent: true
      }
    },
    {
      path: "/",
      component: Main,
      children: routes
    }
  ]
});

let isFirstRouting = true;

/**
 * グローバルガード
 */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + " | Reci BASE" : "Reci BASE";

  // 認証が必要な画面に認証されていない状態で遷移した場合，
  //  ・初回ロード時はログイン画面へリダイレクトします(画面がないので再認証フォームを表示できない)
  //  ・それ以外の遷移では再認証を行います．
  if (
    to.matched.some((record) => !record.meta.isPublic) &&
    !store.getters["auth/authenticated"]()
  ) {
    if (isFirstRouting) {
      next({
        name: "login",
        query: { prev: to.fullPath }
      });
    } else {
      store.commit("auth/reAuthorize");
    }

    isFirstRouting = false;
    return;
  }

  // アクセス権限のない画面へ遷移しようとした場合，通知して遷移を取り消します
  if (
    to.matched.some(
      record =>
        (record.meta.isProvider && !store.getters["auth/isProvider"])
        || (record.meta.isPermitMakerView &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionMakerView"])
        || (record.meta.isPermitMakerEdit &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionMakerEdit"])
        || (record.meta.isPermitUserView &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionUserView"])
        || (record.meta.isPermitUserEdit &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionUserEdit"])
        || (record.meta.isPermitArticleView &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionArticleView"])
        || (record.meta.isPermitArticleEdit &&
        store.getters["auth/isProvider"] && !store.getters["auth/permissionArticleEdit"])
    )
  ) {
    utility
      .$alert("アクセス権限がありません。", "エラー", {
        confirmButtonText: "OK",
        type: "error",
        center: true
      })
      .then(() => {
        next({
          name: "dashboard"
        });
      })
      .catch(() => {
        next({
          name: "dashboard"
        });
      });

    isFirstRouting = false;
    return;
  }

  if (
    to.matched.some(
      record =>
        (record.meta.isMaker && store.getters["auth/isProvider"])
    )
  ) {
    utility
      .$alert("アクセス権限がありません。", "エラー", {
        confirmButtonText: "OK",
        type: "error",
        center: true
      })
      .then(() => {
        next({
          name: "dashboard"
        });
      })
      .catch(() => {
        next({
          name: "dashboard"
        });
      });

    isFirstRouting = false;
    return;
  }

  // 確認画面でリロードした場合の対応
  if (isFirstRouting) {
    if (to.path.match(/^.+\/confirm$/) || to.path.match(/^.+complete$/)) {
      isFirstRouting = false;
      const segments = to.path.split("/");
      segments.pop();
      next(segments.join("/"));
      return;
    }
  }

  // フォームが編集状態の場合ダイアログを表示します
  if (store.state.form && store.getters["form/isAnyDirty"]) {
    // 編集確認へ遷移する際は、ダーティーチェックを無視
    if (to.path.match(/^.+\/confirm$/)) {
      isFirstRouting = false;
      next();
      return;
    }

    utility
      .$confirm("このまま移動すると変更が保存されません。", "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true
      })
      .then(() => {
        next();
      })
      .catch(() => {
        next(false);
      });

    isFirstRouting = false;
    return;
  }

  if (from.path.split("/")[1] !== to.path.split("/")[1]) {
    store.dispatch("filters/initialize");
  }

  isFirstRouting = false;
  next();
});

/**
 * グローバルAfterフック
 */
router.afterEach(() => {
  if (store.state.form) {
    store.commit("form/clearDirty");
  }
});

export default router;
